
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93X0hQp1jpO9Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93RS2S7MlDmsMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/blogg/[...slug].vue?macro=true";
import { default as index8cdxWXuxeKMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/blogg/index.vue?macro=true";
import { default as indexOS11RCPzoRMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/checkout/index.vue?macro=true";
import { default as paymentBasHdSwvHEMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/checkout/payment.vue?macro=true";
import { default as index_46clienthfmhK6uM6sMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as index7h1YHbosg0Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/collections/index.vue?macro=true";
import { default as _91slug_9392O2KZfS1bMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/faq/[slug].vue?macro=true";
import { default as indexgYe2RSqM2MMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as indexk4hCQDVcIiMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/index.vue?macro=true";
import { default as indexi3w7hGBkxlMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/login/index.vue?macro=true";
import { default as _91id_93f60gKASnw2Meta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/qr-pr/[id].vue?macro=true";
import { default as _91_46_46_46slug_93aWnjKXdjciMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/shop/[...slug].vue?macro=true";
import { default as index1AdPX5jxBcMeta } from "/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___da",
    path: "/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___da",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___da",
    path: "/blogg",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___da",
    path: "/checkout",
    meta: indexOS11RCPzoRMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___da",
    path: "/checkout/payment",
    meta: paymentBasHdSwvHEMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___da",
    path: "/checkout/thank-you",
    meta: index_46clienthfmhK6uM6sMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___da",
    path: "/samlinger",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___da",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___da",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___da",
    path: "/",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/index.vue")
  },
  {
    name: "login___da",
    path: "/login",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___da",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/qr-pr/[id].vue")
  },
  {
    name: "shop-slug___da",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___da",
    path: "/track",
    meta: index1AdPX5jxBcMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.dk/releases/20250425071940Z/pages/track/index.vue")
  }
]